import clsx from "clsx";
import { snakeCase } from "lodash";
import React from "react";
import { Button, Dropdown } from "react-bootstrap";
import { DropdownContainerProps } from "../@types";
import Icon from "../Icon";
import { dropdownContainerClassName } from "./consts";

export const DropdownContainerHeader = ({
  children
}: {
  children: React.ReactNode;
}): JSX.Element => (
  <div className="custom-dropdown-container__header">{children}</div>
);

const DropdownContainer = ({
  name,
  disabled = false,
  autoClose = true,
  show = false,
  className,
  buttonVariant = "menu-primary",
  buttonLabel,
  buttonSize,
  buttonIcon,
  buttonClassName,
  showDropdownIcon = true,
  children,
  onSelect,
  buttonComponent = Button,
  limitMenuHeight = false,
  menuItemDisplay,
  labelWidthLimit,
  ...otherProps
}: DropdownContainerProps) => (
  <Dropdown
    show={show}
    autoClose={autoClose}
    className={clsx(
      dropdownContainerClassName,
      className,
      menuItemDisplay?.compact && `${dropdownContainerClassName}--compact`,
      menuItemDisplay?.indented && `${dropdownContainerClassName}--indented`
    )}
    onSelect={onSelect}
    {...otherProps}
  >
    <Dropdown.Toggle
      id={`${name}-dropdown-toggle`}
      data-testid={`${snakeCase(name)}_dropdown_toggle`}
      variant={buttonVariant}
      disabled={disabled}
      className={buttonClassName}
      size={buttonSize as any}
      as={buttonComponent}
    >
      {buttonIcon ? (
        <Icon name={buttonIcon} className="filter-type-icon" />
      ) : null}
      <span
        className="dropdown-toggle__label"
        style={labelWidthLimit ? { maxWidth: labelWidthLimit } : {}}
      >
        {buttonLabel}
      </span>
      {showDropdownIcon ? (
        <Icon name="chevron-down" className="dropdown-toggle__chevron-icon" />
      ) : null}
    </Dropdown.Toggle>
    <Dropdown.Menu
      data-testid={`${snakeCase(name)}_dropdown_menu`}
      style={limitMenuHeight ? { maxHeight: "350px", overflowY: "auto" } : {}}
    >
      {children}
    </Dropdown.Menu>
  </Dropdown>
);

export default DropdownContainer;
